import { useQuery } from "@tanstack/react-query";

import useUserSessionApi from "./user-sessions-api";
import { IS_MFA_ENROLLED_QUERY_KEY } from "./query-keys";

export default function useIsMfaEnrolled(props?: {
  refetchInterval?: number;
  enabled?: boolean;
}) {
  const { refetchInterval, enabled = true } = props || {};

  const api = useUserSessionApi();

  const fetchMethod = async () => {
    return api.isMfaEnrolled();
  };

  return useQuery({
    queryKey: [IS_MFA_ENROLLED_QUERY_KEY],
    queryFn: fetchMethod,
    refetchInterval,
    enabled,
  });
}
